import { render, staticRenderFns } from "./MessagesManagerment.vue?vue&type=template&id=487d13f7&scoped=true"
import script from "./MessagesManagerment.vue?vue&type=script&lang=js"
export * from "./MessagesManagerment.vue?vue&type=script&lang=js"
import style0 from "./MessagesManagerment.vue?vue&type=style&index=0&id=487d13f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d13f7",
  null
  
)

export default component.exports